import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import VimeoCard from '../components/VimeoCard';

function AdminArchivingGroups() {
    return (
        <>
            {/* Grid container to hold the rows */}
            <Grid container spacing={3}>
                <Grid item xs={12} sx={{ marginBottom: 10, marginTop: 15 }}>
                    <Typography
                        variant={'caption'}
                        align={'center'}
                        fontSize={25}
                        sx={{ margin: 8, marginBottom: 10 }}
                    >
                        1TUL allows you to easily keep your group list up to date and easy to
                        navigate. {''}
                        <strong>Organization Administrators </strong>can archive unused or old
                        groups to hide them from the group list view.
                    </Typography>
                </Grid>
                <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid item xs={12} sx={{ marginBottom: 10, marginTop: 15 }}>
                        <VimeoCard
                            width={650}
                            videoUrl={
                                'https://player.vimeo.com/video/900393420?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                            }
                            title={'Archive Groups'}
                            description={'Keep your Group List easy to view and navigate.'}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default AdminArchivingGroups;
